import { ScrollView, View } from "react-native";
import { SafeAreaView } from "react-native-safe-area-context";

import { Text, TextClassContext } from "@/components/ui/text";
import { useTranslation } from "react-i18next";
import { getAppVersionLabel } from "../../lib/appVersion";
import AppearanceSettings from "./settings/AppearanceSettings";
import NotificationsSettings from "./settings/NotificationsSettings";
import SecuritySettings from "./settings/Security";

export default function SettingsScreen() {
    const { t } = useTranslation();
    return (
        <SafeAreaView className="flex-1 bg-background" edges={["bottom"]}>
            <ScrollView
                className="flex-1"
                contentContainerClassName="gap-6 px-4 pb-6 pt-2 web:mx-auto web:w-full web:max-w-lg"
            >
                <SecuritySettings />
                <NotificationsSettings />
                <AppearanceSettings />
                <View className="mt-10 flex-1 items-center justify-center">
                    <TextClassContext.Provider value="text-xs">
                        <Text variant="caption">
                            {t("settings.copyright", {
                                year: new Date().getFullYear(),
                            })}
                        </Text>
                        <Text variant="caption">
                            {t("settings.copyrightRights")}
                        </Text>
                        <Text variant="caption">
                            {t("settings.version", {
                                version: getAppVersionLabel(),
                            })}
                        </Text>
                    </TextClassContext.Provider>
                </View>
            </ScrollView>
        </SafeAreaView>
    );
}
